import {useIntl} from '@umijs/max';
import useTrans from '@/hooks/useTranslateGoogleHook';
import formKeys from '@/locales/zh-CN/forms'

// 自定义 Hook：获取格式化后的消息
const useFormattedMessage = () => {
    const values = Object.values(formKeys)
    const {langs} = useTrans({keys:values})
    const intl = useIntl(); // ✅ 正确：在自定义 Hook 内部调用 useIntl
    const labelGroup = {
        name: langs[formKeys['form.name']] ,
        lastName: langs[formKeys['form.last-name']] ,
        firstName: langs[formKeys[ 'form.first-name']] ,
        email: langs[formKeys[ 'form.email']],
        emailCode: langs[formKeys[ 'form.email.code']],
        country: langs[formKeys[ 'form.country']],
        password: langs[formKeys[ 'form.password']],
        requiredText: langs[formKeys[ 'form.requiredText']],
        idCardFront: langs[formKeys[ 'form.upload.idFront']],
        idCardBack: langs[formKeys[ 'form.upload.idBack']],
        birthday: langs[formKeys[ 'form.birthday']],
        nickname: langs[formKeys[ 'form.nickname']],
        phone: langs[formKeys[ 'form.phone']],
        state: langs[formKeys[ 'form.state']],
        city: langs[formKeys[ 'form.city']],
        address: langs[formKeys[ 'form.address']],
        // reset: langs[formKeys[ 'form.reset']],
        submit: langs[formKeys[ 'form.submit']],
    }
    const formatterMessage = (id)=>intl.formatMessage({id})
    return {labelGroup,formatterMessage}
}
export default useFormattedMessage